import { Button } from '@think-internet/ui-components'
import styled from 'styled-components'

export const StyledConsent = styled.div`
  &.hidden {
    display: none;
  }
  position: fixed;
  z-index: 10000;
  height: 100%;
  width: 100%;
  text-align: center;
  @media (max-width: ${({ theme }) => theme.breakpoint.md}) {
    display: flex;
    align-items: flex-end;
    justify-content: center;
  }
`

export const Content = styled.div`
  display: inline-block;
  width: 60%;
  margin-top: 10%;
  border-radius: ${({ theme }) => theme.border.radius};
  background-color: ${({ theme }) => theme.color.background.white};
  box-shadow: 0px 0px 10px rgba(168, 168, 168, 1);
  @media (max-width: ${({ theme }) => theme.breakpoint.md}) {
    width: 90%;
    margin-bottom: 5%;
  }
`

export const Headline = styled.div`
  padding: 15px;
  font-size: 20px;
  background-color: ${({ theme }) => theme.color.backgroundWhite};
  text-align: center;
`

export const Text = styled.div`
  padding: 15px;
  font-size: 14px;
`

export const Interaction = styled.div`
  padding: 10px;
  background-color: ${({ theme }) => theme.color.backgroundWhite};
  color: ${({ theme }) => theme.color.secondary};
  display: flex;
  @media (max-width: ${({ theme }) => theme.breakpoint.md}) {
    display: block;
  }
`

export const ButtonWrapper = styled.div`
  width: 50%;
  text-align: center;
  @media (max-width: ${({ theme }) => theme.breakpoint.md}) {
    &:first-child {
      margin-bottom: 10px;
    }
    width: 100%;
  }
`
export const CustomButton = styled(Button)`
  font-size: 18px;
  color: ${({ theme }) => theme.color.secondary};
  outline: none;
  box-shadow: none;
  border: none;
  width: 100%;
  ${({ transparent, theme }) => `
    background-color: ${transparent ? 'transparent' : theme.color.background.thirdary};
  `}
`
